

import React, { forwardRef, useEffect, useState } from "react";
import moment from "moment";
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import AttachEmailSharpIcon from '@mui/icons-material/AttachEmailSharp';
import LinkSharpIcon from '@mui/icons-material/LinkSharp';
// import logo22 from "../../assets/images/logo22.png"


const ResumePdf = forwardRef(({
    userDataInfo,
    userCertification,
    userExperience,
    userAwards,
    projectData,
    userSkill,
    userEducation
}, ref) => {


    console.log('userDataInfo', userDataInfo);
    console.log("Image URL:", userDataInfo?.userImage);
    console.log('userCertification', userCertification);
    console.log('userExperience', userExperience);
    console.log('userAwards', userAwards);
    console.log('projectData', projectData);
    console.log('userSkill', userSkill);
    console.log('userEducation', userEducation);

    return (

        <div
            id="pdfContent" // Add an ID for targeting
            ref={ref}
            style={{
                width: "1200px",
                // height: "1000px",
                backgroundColor: "white",
                padding: "20px",
                marginBottom: "10px",
                marginTop: "10px",
                fontFamily: "PlusJakartaSans-Regular",
            }}
        >

            <section className="candidates-section mt-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 cl-md-8"> 
                            {
                                userDataInfo === "" ? (
                                    <h5 className="mt-5 d-flex justify-content-center">
                                        No Data Available
                                    </h5>
                                ) : (
                                    <div className="wd-cv-item">
                                        <div className="item-group">
                                            <div className="content-left">

                                                {/* {userDataInfo?.userImage === null ? (
                                                    ""
                                                ) : (
                                                    <div className="avatar">
                                                        <img
                                                            src={userDataInfo.userImage}
                                                            alt="images"
                                                            style={{ width: "200px", height: "200px",
                                                                 objectFit: "cover",backgroundColor:"red",
                                                                borderRadius: "50%" }}
                                                        />
                                                    </div>
                                                )} */}


                                                {userDataInfo?.userImage ? (
                                                    <div className="avatar">
                                                        <img
                                                            src={userDataInfo.userImage}
                                                            // src={logo22}
                                                            alt="user-avatar"
                                                            crossOrigin="anonymous" // Add this line to allow CORS
                                                            style={{
                                                                width: "200px", height: "200px",
                                                                objectFit: "cover", backgroundColor: "red",
                                                                borderRadius: "50%"
                                                            }}
                                                            onLoad={() => console.log('Image loaded successfully')}
                                                        />
                                                    </div>
                                                ) : (
                                                    <p>No Image Available</p>
                                                )}




                                                <div className=" border-bottom">
                                                    <h6 className="title-cv mb-2">Contact</h6>
                                                </div>
                                                {userDataInfo?.email === null ? (
                                                    ""
                                                ) : (
                                                    <div className="content persnol-info mt-2">
                                                        <div className="d-flex">
                                                            <AttachEmailSharpIcon className="me-2" /> <p>{userDataInfo.email}</p>
                                                        </div>
                                                    </div>
                                                )}
                                                {userDataInfo?.dob === null ? (
                                                    ""
                                                ) : (
                                                    <div className="content mb-2">
                                                        <div className="d-flex">
                                                            <CalendarMonthSharpIcon className="me-2" /> <p>{userDataInfo.dob}</p>
                                                        </div>
                                                    </div>
                                                )}
                                                {userDataInfo?.webSiteLink === null ? (
                                                    ""
                                                ) : (
                                                    <div className="content mb-2">
                                                        <div className="d-flex">
                                                            <LinkSharpIcon className="me-2" /> <p>{userDataInfo.webSiteLink}</p>
                                                        </div>
                                                    </div>
                                                )}
                                                {userDataInfo?.languages?.length > 0 ? (
                                                    <div className="content">
                                                        <div className="d-flex">
                                                            <LanguageSharpIcon className="me-2" />
                                                            {userDataInfo.languages.map((language, index) => (
                                                                <p key={index} className="me-2">
                                                                    {language}
                                                                </p>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}

                                                {userAwards.length === 0 ? (
                                                    ""
                                                ) : (
                                                    <>
                                                        <div className="content award mt-3">
                                                            <div className="d-flex border-bottom">
                                                                <h6 className="title-cv mb-1">Awards</h6>
                                                            </div>
                                                            <div className="mb-1">
                                                                <ul className="list-dot mb-1 ps-0">
                                                                    {userAwards && userAwards
                                                                        .filter((item) => !item.isDeleted)
                                                                        ?.map((item, index) => (  // Add index here if item doesn't have a unique id
                                                                            <li key={item.id || index} className="listIcon mt-1">
                                                                                <div className="row">
                                                                                    <div className="d-flex align-center mb-0">
                                                                                        <p className="me-1 mb-0">{item.name}</p>
                                                                                        <p className="my-0 f-14 mt-1 ms-1">
                                                                                            {moment(item?.issueDate).format("MMM YYYY")}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="d-flex align-center mb-0">
                                                                                        <p className="me-2 mb-0 f-14">{item.orgName}</p>
                                                                                        <p className="me-2 my-0 f-14">({item.cityName})</p>
                                                                                        <p className="my-0 f-12 mt-1">{item.description}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {/*................ 3 ..............*/}


                                                {userSkill.length === 0 ? (
                                                    ""
                                                ) : (
                                                    <>
                                                        <div className="content skill mt-3">
                                                            <div className="d-flex border-bottom">
                                                                <h6 className="title-cv mb-1">Skills</h6>
                                                            </div>
                                                            <div className="mb-1">
                                                                <ul className="list-dot mb-1 ps-0">
                                                                    {userSkill &&
                                                                        userSkill
                                                                            .filter((item) => !item.isDeleted)
                                                                            ?.map((item, index) => (
                                                                                <li key={item.id || index} className="listIcon mb-0 ms-3 mt-1">
                                                                                    <p className="mb-0 f-14">{item.skillName}</p>
                                                                                </li>
                                                                            ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {/*................ 4 ..............*/}

                                                {userCertification.length === 0 ? (
                                                    ""
                                                ) : (
                                                    <>
                                                        <div className="content certificate mt-3">
                                                            <div className="d-flex border-bottom">
                                                                <h6 className="title-cv mb-1">Certificate</h6>
                                                            </div>
                                                            <div className="mb-1">
                                                                {userCertification &&
                                                                    userCertification
                                                                        .filter((item) => !item.isDeleted)
                                                                        .map((item, index) => (
                                                                            <ul key={item.id || index} className="list-dot mb-1 ps-0">
                                                                                <li className="listIcon mt-1">
                                                                                    <div className="row">
                                                                                        <div className="d-flex align-center mb-0">
                                                                                            <p className="mb-0">{item.name}</p>
                                                                                        </div>
                                                                                        <div className="d-flex align-center mb-0">
                                                                                            <p className="me-2 mb-0 f-14">{item.orgName}</p>
                                                                                            <p className="mb-0 f-14">
                                                                                                {moment(item?.issueDate).format("MMM YYYY")}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            </ul>
                                                                        ))}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {/*................ 5 ..............*/}

                                                {projectData.length === 0 ? (
                                                    ""
                                                ) : (
                                                    <>
                                                        <div className="content project mt-3">
                                                            <div className="d-flex border-bottom">
                                                                <h6 className="title-cv mb-1">Projects</h6>
                                                            </div>
                                                            <div className="mb-1">
                                                                {projectData &&
                                                                    projectData
                                                                        .filter((item) => !item.isDeleted)
                                                                        ?.map((item, index) => (
                                                                            <ul key={item.id || index} className="list-dot mb-1 ps-0">
                                                                                <li className="listIcon mt-1">
                                                                                    <div className="row">
                                                                                        <div className="d-flex align-center mb-0">
                                                                                            <p className="mb-0 view-title f-">{item.name}</p>
                                                                                        </div>
                                                                                        <div className="d-flex align-center mb-0">
                                                                                            <p className="mb-0 f-14">
                                                                                                {item.orgName} {item.startMonth}/{item.startYear} -{" "}
                                                                                                {item.endMonth}/{item.endYear}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            </ul>
                                                                        ))}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}


                                            </div>
                                            <div className="content-right">
                                                <div className="profile">
                                                    <h2>{userDataInfo.fullName}</h2>
                                                    <h4>{userDataInfo.currentCity}</h4>
                                                    <h6>{userExperience.headLine}</h6>
                                                    <p>
                                                        {userDataInfo.about}
                                                    </p>
                                                </div>

                                                {/*................ 6 ..............*/}


                                                {userExperience.length === 0 ? (
                                                    ""
                                                ) : (
                                                    <>
                                                        <div className="content Experience mt-3">
                                                            <div className="border-bottom">
                                                                <h6 className="title-cv  mb-2">
                                                                    Experience</h6>
                                                            </div>
                                                            <div className="cv-road-map mt-2">
                                                                {userExperience && userExperience
                                                                    .filter((item) => !item.isDeleted)
                                                                    ?.map((data, index) => (
                                                                        <div key={data.id || index} className="inner">
                                                                            <div className="history">{data.startDate}</div>
                                                                            <div className="dot-icon"></div>
                                                                            <div className="content">
                                                                                <h6>{data.jobTitle}</h6>
                                                                                <div className="sub-heading ps-2 mb-1">{data.cityName}</div>
                                                                                <ul className="list-dot mb-0 ps-1">
                                                                                    <li>{data.description}
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    ))}


                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {/*................ 7 ..............*/}


                                                {userEducation.length === 0 ? (
                                                    ""
                                                ) : (
                                                    <>
                                                        <div className="content Education mt-3">
                                                            <div className="border-bottom">
                                                                <h6 className="title-cv  mb-2">
                                                                    Education</h6>
                                                            </div>
                                                            <div className="cv-road-map edu-map mt-2">
                                                                {userEducation && userEducation
                                                                    .filter((item) => !item.isDeleted)
                                                                    ?.map((edu) => (

                                                                        <div className="inner">
                                                                            <div className="history">{edu.startMonth}/{edu.startYear}- {edu.endYear} </div>
                                                                            <div className="dot-icon"></div>
                                                                            <div className="content">
                                                                                <h6>{edu.institutionName}</h6>
                                                                                <ul className="list-dot mb-0 ps-0">
                                                                                    <li>{edu.description}
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    ))}

                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>

                </div>
            </section>

        </div>

    );
});



export default ResumePdf;
